// extracted by mini-css-extract-plugin
export default {"link":"useColumns_link__UA5rM","profiles":"useColumns_profiles__312-i","actionColumn":"useColumns_actionColumn__GciBs"};